import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import LeadsPage from "./pages/LeadsPage";
import LeadFunnelPage from "./pages/LeadFunnelPage";
import CommissionsPage from "./pages/CommissionsPage";
import TeamPage from "./pages/TeamPage";
import ClientAreaPage from "./pages/ClientAreaPage";
import AgendaPage from "./pages/AgendaPage";
import AgendaTVPage from "./pages/AgendaTVPage";
import CommunicationPage from "./pages/CommunicationPage";
import PaymentsPage from "./pages/PaymentsPage";
import ReportsPage from "./pages/ReportsPage";
import InsurancePage from "./pages/InsurancePage";
import BannersPage from "./pages/BannersPage";
import ReferralsPage from "./pages/ReferralsPage";
import ClientsManagePage from "./pages/ClientsManagePage";
import ClientProfilePage from "./pages/ClientProfilePage";
import ConsortiumsPage from "./pages/ConsortiumsPage";
import VigiaPage from "./pages/VigiaPage";
import DoletasPage from "./pages/DoletasPage";
import "./services/vigia";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
          <Route
            path="/painel"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader"]}>
                <LeadsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/funil-leads"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader"]}>
                <LeadFunnelPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comissoes"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <CommissionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/equipe"
            element={
              <ProtectedRoute roles={["admin", "team_leader", "assistant"]}>
                <TeamPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agenda"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <AgendaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agenda/tv"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <AgendaTVPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comunicacao"
            element={
              <ProtectedRoute roles={["admin", "assistant"]}>
                <CommunicationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pagamentos"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <PaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/relatorios"
            element={
              <ProtectedRoute roles={["admin", "team_leader", "assistant"]}>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seguros"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <InsurancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/banners"
            element={
              <ProtectedRoute roles={["admin", "assistant"]}>
                <BannersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/indicacoes"
            element={
              <ProtectedRoute roles={["admin", "team_leader", "broker", "assistant"]}>
                <ReferralsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <ClientsManagePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/:id"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <ClientProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/consorcios"
            element={
              <ProtectedRoute roles={["admin", "broker", "team_leader", "assistant"]}>
                <ConsortiumsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vigia"
            element={
              <ProtectedRoute roles={["admin"]}>
                <VigiaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/doletas"
            element={
              <ProtectedRoute roles={["admin"]}>
                <DoletasPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cliente"
            element={
              <ProtectedRoute roles={["client", "admin"]}>
                <ClientAreaPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/painel" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
